/* eslint-disable indent */
import { html, css, LitElement } from 'lit';
import { customElement, query, state } from 'lit/decorators.js';
import { connect } from 'pwa-helpers/connect-mixin.js';
import { store } from '../../store/store.js';
import { filterMicrolearnings } from '../../store/microlearning/microlearning.js';
import { getIcon } from '../../store/microlearning/helpers.js';
import { translate } from '../../helpers/translate.js';
import '@polymer/paper-input/paper-input.js';
import '@polymer/paper-listbox/paper-listbox.js';
import '@polymer/paper-item/paper-icon-item.js';
import '@polymer/paper-item/paper-item-body.js';
import '../shared/sdb-dialog.js';

@customElement('sdb-microlearning-select')
class SdbMicrolearningSelect extends connect(store)(LitElement) {

    @state()
    accessor filteredList = [];

    @state()
    accessor searchText = '';

    @state()
    accessor selectedListItem = null;

    @query('#search')
    accessor searchInput;

    @query('#ml_list')
    accessor listbox;

    stateChanged(state) {
        this.filteredList = state.microlearning.filteredList || [];
        this.searchText = state.microlearning.filter || '';
    }

    static get styles() {
        return css`

            .filter-bar sdb-search-input {
                margin-left: 20px;
                width: 90%;
            }

            .list {
                height: 550px;
                width: 900px;
                overflow-y: auto;
            }

            #ml_list {
                contain: none !important; /* lit-virtualizer hack */
            }

            sdb-content-listitem {
                width: 100%; /* lit-virtualizer screws this up */
            }

            sdb-content-listitem.selected {
                font-weight: bold;
                background: rgba(0, 0, 0, 0.1);
            }

            .results {
                margin-left: 20px;
                opacity: .8;
            }
        `;
    }

    render() {
        return html`
            <div id="filterbar">
                <sdb-search-input
                    id="search"
                    placeholder=${translate('search')}
                    value=${this.searchText}
                    has-border
                    @search=${(e) => {
                        store.dispatch(filterMicrolearnings({ searchText: e.detail.searchText }));
                        this._reset();
                    }}>
                </sdb-search-input>
            </div>
            <div class="results">${translate('numberResults')}: ${this.filteredList.length}</div>

            <div class="list">
                ${!this.filteredList.length === 0
                    ? html`<sdb-status-message label=${translate('noMicrolearningsFound')}></sdb-status-message>`
                    : html`
                        <sdb-content-list id="ml_list">
                            <lit-virtualizer
                                .items=${this.filteredList}
                                .renderItem=${(item) => this._renderMicrolearningListItem(item)}
                                .scrollTarget=${document}>
                            </lit-virtualizer>
                        </sdb-content-list>`
                }
            </div>
        `;
    }

    _renderMicrolearningListItem(item) {
        return html`
            <sdb-content-listitem
                icon=${getIcon(item.contentType)}
                headline=${item.name}
                subtitle=${item.contextName}
                @click=${(e) => { this._select(item, e.target) }}>
            </sdb-content-listitem>
        `;
    }

    _select(item, target) {
        if (this.selectedListItem === target) {
            this._reset();

            this.dispatchEvent(new CustomEvent('selected', {
                detail: {
                    value: null,
                },
                composed: true,
                bubbles: true,
            }));
            return;
        }

        if (this.selectedListItem) {
            this.selectedListItem.classList.remove('selected');
        }

        this.selectedListItem = target;
        this.selectedListItem.classList.add('selected');

        this.dispatchEvent(new CustomEvent('selected', {
            detail: {
                value: item,
            },
            composed: true,
            bubbles: true,
        }));
    }

    _reset() {
        if (this.selectedListItem) {
            this.selectedListItem.classList.remove('selected');
        }

        this.selectedListItem = null;
    }
}

